// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Nf7x","searchIcon":"File_searchIcon__IXZ5B"};